'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasds';
var iconName = 'ice-cream';
var width = 384;
var height = 512;
var aliases = [127848];
var unicode = 'f810';
var svgPathData = ['M0 224l0 32 384 0 0-32c0-30.2-20.9-55.5-49.1-62.3 .7-5.8 1.1-11.7 1.1-17.7 0-79.5-64.5-144-144-144S48 64.5 48 144c0 6 .4 11.9 1.1 17.7-28.2 6.7-49.1 32-49.1 62.3z', 'M192 544L48 256 336 256 192 544z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faIceCream = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;